import { useState } from "react";
import { PageHeader } from "@/components/layout/Layout";
import { TabPanel, Tabs } from "@/components/ui";
import { CompanyTab } from "./CompanyTab";
import { BrandingTab } from "./BrandingTab";
import { StandardTextsTab } from "./StandardTextsTab";
import { ModulesTab } from "./ModulesTab";
import { NumbersTab } from "./NumbersTab";
import { TaxBackupTab } from "./TaxBackupTab";
import { IntegrationsTab } from "./IntegrationsTab";
import { PdfLayoutTab } from "./PdfLayoutTab";
import { AccountTab } from "./AccountTab";

const TABS = [
  { value: "company", label: "Unternehmen" },
  { value: "branding", label: "Branding" },
  { value: "texts", label: "Textbausteine" },
  { value: "pdf", label: "PDF-Layout" },
  { value: "numbers", label: "Nummernkreise" },
  { value: "modules", label: "Module" },
  { value: "tax", label: "Steuer & Backup" },
  { value: "integrations", label: "Versand & API" },
  { value: "account", label: "Konto" },
];

export function Settings() {
  const [tab, setTab] = useState("company");
  return (
    <div className="flex flex-col h-full">
      <PageHeader title="Einstellungen" />
      <Tabs value={tab} onValueChange={setTab} tabs={TABS}>
        <div className="flex-1 overflow-y-auto">
          <TabPanel value="company">
            <CompanyTab />
          </TabPanel>
          <TabPanel value="branding">
            <BrandingTab />
          </TabPanel>
          <TabPanel value="texts">
            <StandardTextsTab />
          </TabPanel>
          <TabPanel value="modules">
            <ModulesTab />
          </TabPanel>
          <TabPanel value="numbers">
            <NumbersTab />
          </TabPanel>
          <TabPanel value="pdf">
            <PdfLayoutTab />
          </TabPanel>
          <TabPanel value="tax">
            <TaxBackupTab />
          </TabPanel>
          <TabPanel value="integrations">
            <IntegrationsTab />
          </TabPanel>
          <TabPanel value="account">
            <AccountTab />
          </TabPanel>
        </div>
      </Tabs>
    </div>
  );
}
